const getChartData = (data, key, subKey, valueKey, labelKey) => {
  const barChartLabels = data.map((item) => item[labelKey]);
  const barChartData = data.reduce((acc, curr) => {
    const chartData = curr[key];
    chartData.forEach((item) => {
      if (!acc[item[subKey]]) {
        acc[item[subKey]] = [item[valueKey]];
      } else {
        acc[item[subKey]] = [...acc[item[subKey]], item[valueKey]];
      }
    });
    return acc;
  }, {});

  const pieLabels = Object.keys(barChartData);
  const pieChartData = Object.values(barChartData).map((item) =>
    item.reduce((a, b) => a + b, 0)
  );

  return {
    barChartLabels,
    barChartData,
    pieLabels,
    pieChartData,
  };
};
export default getChartData;
